import { Icon56CheckCircleOutline, Icon56InfoOutline } from '@vkontakte/icons';
import { Button, Text, Title } from '@vkontakte/vkui';
import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { B2B_ALLDOCUMENTS_REQUEST_BUTTON } from 'reactApp/appHelpers/featuresHelpers/features/unpaidB2BDisableAllDocuments';
import { checkAllDocumentsUnlockRequest, sendAllDocumentsUnlockRequest } from 'reactApp/modules/allDocuments/allDocuments.module';
import { getAllDocumentsAccessRequestSent } from 'reactApp/modules/allDocuments/allDocuments.selectors';

import styles from './AllDocumentsDisabledPopup.css';

const AllDocumentsDisabledBizPopup = memo(() => {
    const dispatch = useDispatch();

    const messageSent = useSelector(getAllDocumentsAccessRequestSent);

    const handleSendAllDocsUnlockRequest = () => {
        dispatch(sendAllDocumentsUnlockRequest());
    };

    useEffect(() => {
        dispatch(checkAllDocumentsUnlockRequest());
    }, []);

    const content = useMemo(() => {
        if (messageSent) {
            return {
                icon: <Icon56CheckCircleOutline className={styles.icon} />,
                title: 'Запрос отправлен',
                description: 'Как только администратор выберет тариф — сможете пользоваться всеми функциями',
            };
        } else if (B2B_ALLDOCUMENTS_REQUEST_BUTTON) {
            return {
                icon: <Icon56InfoOutline className={styles.icon} />,
                title: 'Это — Документы',
                description: 'Редактируйте, создавайте новые, работайте вместе. Для подключения этих функций выберите тариф',
            };
        }
        return {
            icon: <Icon56InfoOutline className={styles.icon} />,
            title: 'Это — Документы',
            description: 'Редактируйте, создавайте новые, работайте вместе.\nДля подключения этих функций обратитесь\nк администратору',
        };
    }, [messageSent]);

    return (
        <div data-qa-id="alldocuments-disable-popup-content" className={styles.content}>
            {content.icon}
            <Title data-qa-id="alldocuments-disable-popup-title">{content.title}</Title>
            <Text data-qa-id="alldocuments-disable-popup-description" className={styles.description}>
                {content.description}
            </Text>
            {!messageSent && B2B_ALLDOCUMENTS_REQUEST_BUTTON && (
                <Button
                    data-qa-id="alldocuments-disable-popup-request-button"
                    size="l"
                    mode="secondary"
                    appearance="neutral"
                    onClick={handleSendAllDocsUnlockRequest}
                >
                    Подключить через администратора
                </Button>
            )}
        </div>
    );
});

AllDocumentsDisabledBizPopup.displayName = 'AllDocumentsDisabledBizPopup';

export default AllDocumentsDisabledBizPopup;
